<div class="card mb-0">
    <div class="card-body d-flex flex-column align-items-center">
        <div class="close-btn align-self-end mb-2 cursor-pointer" (click)="dismissModal()">
            <i data-feather="x" [size]="30"></i>
        </div>
        <img src="../../../../assets/img/learning.png" alt="" height="55" class="mb-2" />
        <img src="../../../../assets/img/Layer_1.png" alt="" height="210" class="mb-2" />
        <ng-container *ngIf="errorMessage; else noError">
            <p class="mb-md-2 text-center error">{{ errorMessage }}</p>
        </ng-container>
        <ng-template #noError>
            <h2 class="mb-2 text-center">Contest Completed <span>{{ userName }}</span></h2>
            <p class="text-center mb-2">Sign up to create your own beewiz contest</p>
        </ng-template>

        <button class="btn btn-primary btn-md mb-1" (click)="navigateToSignUpPage()">
            Sign Up
        </button>
        <p class="sign-in mb-0 text-center">
            Already Have An Account? <a href="" (click)="navigateToLoginPage()">Sign In</a>
        </p>
    </div>
</div>